import { Component, OnInit, trigger, state, style, transition, animate, ChangeDetectorRef, AfterViewInit, OnDestroy  } from '@angular/core';
import { Router } from '@angular/router';
import { LocalUtils } from '../../restricted/restricted.utils';
import { ToasterService, ToasterConfig }  from 'angular2-toaster/angular2-toaster';
import { HeaderService } from '../../components/app-header/app.header.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html',
  animations: [
    trigger('breadcrumbsVisibility', [
      state('hidden', style({
        opacity: 0,
        display: 'none'
      })),
      state('visible', style({
        opacity: 1
      })),
      transition('hidden <=> visible', animate('0.5s  ease-in'))
    ])
  ]
})

export class FullLayoutComponent implements OnInit, AfterViewInit, OnDestroy { 

  user: any = {};
  public state: string = 'visible';
  public hide: boolean = false;
  interval;
  lastScrollTop = 0;
  public connecting: boolean = false;

  public toasterconfig : ToasterConfig =
    new ToasterConfig({
      tapToDismiss: true,
      timeout: 5000
  });

  constructor(private toasterService: ToasterService,
    private cdRef:ChangeDetectorRef,
    private router: Router){

    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    //LocalUtils.timestamps(this.user);

    HeaderService.toaster.subscribe(toaster => {
      this.toasterService.pop(toaster.type, toaster.title, toaster.text);
    });

    HeaderService.connecting.subscribe(r => {
      this.connecting = r;
    });

  }

  ngOnInit() {
    window.addEventListener("scroll", () => {
      let st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > this.lastScrollTop){
        this.state = 'hidden'
        this.hide = true;
      } else {
        this.state = 'visible';
        this.hide = false;
      }
      this.lastScrollTop = st <= 0 ? 0 : st;
    }, false);

    if ((/Firefox/i.test(navigator.userAgent))) {
      document.addEventListener("wheel", e => {
        if (e.deltaY < 0) {
          this.state = 'visible';
          this.hide = false;
        }
      })
    }
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  mousewheel(e) {
    if (e.deltaY < 0 || e.wheelDelta > 0) {
      this.state = 'visible';
      this.hide = false;
    }
  }

  ngAfterViewInit() {
    if (document.getElementById('breadcrumbs')) {
      document.body.appendChild(document.getElementById('breadcrumbs'));
    }
  }

  isAdministrative() {
    switch(this.router.url.split('/')[2]) {
      case 'meeting': {
        if(this.router.url.split('/')[3] == 'start'){
          this.state = 'hidden'
          this.hide = true;
          return true;
        }else{
          return false;
        }
      };
      case 'schedule': return false;
      case 'recordings': return false;
      // case 'reports': {
      //   if(this.router.url.split('/')[3] == 'management'){
      //     this.state = 'hidden'
      //     this.hide = true;
      //     return true;
      //   }else{
      //     return false;
      //   }
      // };
      case 'instructions': return false;

      case 'meetingroom': return false;
      // case 'endpoint': return false;
      // case 'smartroom': return false;
      // case 'calendar': return false;
      case 'oncalendarconfig': return false;
      case 'desk': return false;
      default: {
        this.state = 'hidden'
        this.hide = true;
        return true;
      };
    }
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

}



// WEBPACK FOOTER //
// ./src/app/containers/full-layout/full-layout.component.ts